import { NutsLineItem } from '@/lib/cart/lineItem';
import { checkoutStarted } from '@/rudder-typer';
import { formatStandardProductsItem } from '@/utils/analytics/rudderstack';
import { reportError } from '@/utils/reportError';

export interface NutsCheckoutStarted {
  readonly expressCheckoutMethod?: string;
  readonly lineItems?: NutsLineItem[];
}

export function sendCheckoutStartedEvent(eventProps: NutsCheckoutStarted) {
  try {
    checkoutStarted({
      express_checkout_method: eventProps.expressCheckoutMethod,
      products: eventProps.lineItems?.map((lineItem) => formatStandardProductsItem(lineItem)),
    });
  } catch (e) {
    reportError(e);
  }
}
